import { QueryFunctionContext } from '@tanstack/react-query';
import { UserPhoneNumbersLookupQueryKey } from './props';
import { AxiosInstance, AxiosResponse } from 'axios';
import {
  UserPhoneNumberLookupOutputDto,
  UserPhoneNumbersInputDto,
} from '@starsoft/common/dto';

export async function fetchPhoneNumbersLookup(
  { queryKey }: QueryFunctionContext<UserPhoneNumbersLookupQueryKey>,
  axiosInstance: AxiosInstance,
): Promise<UserPhoneNumberLookupOutputDto> {
  const params: UserPhoneNumbersInputDto = queryKey[1];

  const response: AxiosResponse<UserPhoneNumberLookupOutputDto> =
    await axiosInstance.get<UserPhoneNumberLookupOutputDto>(
      '/user-phone-numbers/lookup',
      {
        params,
      },
    );
  return response.data;
}
